/*!
 * Custom theme js code goes here.
 */
// start mega-menu coding
jQuery(document).ready(($) => {
  // eslint-disable-next-line
  const player = new Plyr("#player"); // home page video
  // eslint-disable-next-line
  const player_popup = new Plyr("#home_popup"); // home popup video
  // console.log("Theme script loadedd");
  $('.modal').modal();
  const expires = 5;
  const delay = 5000;
  setTimeout(() => {
    const videoCookie = $.cookie('video_play');
    if (videoCookie <= 0 || !videoCookie) {
      $('.modal').modal('open');
      // SET A COOKIE TO EXCLUDE USERS FOR 5 DAYS THAT ALREADY HAVE SEEN THE VIDEO.
      $.cookie('video_play', 1, {
        expires,
      });
    }
  }, delay);

  // VIDEO CONTROL BUTTON TO PLAY/PAUSE
  $('.video-play-btn').on('click', () => {
    $('video').trigger($('video').prop('paused') ? 'play' : 'pause');
  });

  // STOP VIDEO WHEN POPUP IS CLOSED.
  $('.closebtn-popup').on('click', () => {
    $('video').trigger('pause');
  });
  $(document).on('click', '.modal-overlay', () => {
    $('video').trigger('pause');
  });

  // Initiate mobile carousel - below is needed for framework, so eslint can ignore
  /* eslint-disable no-unused-vars */
  const swiper = new Swiper('.swiper-container', {
    slidesPerView: 'auto',
    spaceBetween: 10,
    centeredSlides: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
  /**
 *  3D SLIDER
 */
  const swiper3d = new Swiper('.swiper-d-container', {
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    slidesOffsetBefore: -200,
    breakpoints: {
    // when window width is >= 320px
      320: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
    slidesPerView: 'auto',
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    },
    pagination: {
      el: '.swiper-pagination',
    },
  });
  // End carousel
  $('.modal').modal();
  $('.dropdown-trigger').dropdown();
  $('.tooltipped').tooltip();
  $('select').formSelect();
  $('.fixed-action-btn').floatingActionButton({
    direction: 'left',
    hoverEnabled: false,
    toolbarEnabled: false,
  });
  // Pushpin sidebar setup
  $(window).resize(() => {
    if ($(window).width() <= 480) {
      $('#sidebar-right').removeClass('pushpin-side pin-top');
      $('#recent-content').addClass('mobile-carousel');
      // console.log("mobile screen");
    }
    else if ($(window).width() > 480) {
      $('#recent-content').removeClass('mobile-carousel');
      // console.log("larger then mobile screen");
    }
  });
  // MaterialBoxed effect (lightbox) on images
  let materialBoxedCurrentImg = '';
  function materialboxedCheck(toggle) {
    const currentImg = $('.materialboxed.active');
    $(currentImg).parent().addClass('active'); // add active class to its parent aswell.
    // on opening materialboxed effect, look for an img in <picture> sources, in this case we look for 992px breakpoint.
    if (toggle === 'open') {
      materialBoxedCurrentImg = currentImg[0].attributes.src.nodeValue; // save current img
      const pictureSources = currentImg.closest('picture'); // pick the first parent/ancestor matching picture
      const pSourceNodes = pictureSources[0].children; // get all children of <picture>

      let i; // eslint will flip if you dont do this, needed for "for loop"
      for (i = 0; i < pSourceNodes.length; i++) {
        const sourceObj = pSourceNodes[i];
        // if media is defined and contains 992 in string (992px)
        if (sourceObj.media && sourceObj.media.includes('992')) {
        // get the srcset url of source breakpoint '992'
          const sourceObjSrcSet = sourceObj.srcset;
          // grab the string all the way untill first space, we dont need x1 and other stuff afterwards.
          const sourceObjURL = sourceObjSrcSet.split(' ').shift();
          $(currentImg).prop('src', sourceObjURL); // replace src in <img> tag of current img with higher quality img.
        }
      }
      $('body').addClass('materialboxed-active');
    }
    else {
    // on closing materialboxed effect, return originial img (smaller) and remove class from body
      $(currentImg).prop('src', materialBoxedCurrentImg);
      $('body').removeClass('materialboxed-active');
      $(currentImg).parent().removeClass('active'); // remove active class from its parent aswell.
    }
  }
  // materialboxed (lightbox effect)
  $('.materialboxed').materialbox({
    onOpenStart() {
      materialboxedCheck('open');
    },
    onCloseStart() {
      materialboxedCheck('close');
    },
  });

  // create searchform backdrop
  const searchBackDropWrapper = document.createElement('div');
  searchBackDropWrapper.setAttribute('id', 'searchBackDropWrapper');
  $('.page-layout').append(searchBackDropWrapper);

  // init searchform
  $('.search-form-icon-wrapper, #searchBackDropWrapper').on('click', function () {
    const target = $('.js-form-type-search');
    const pageBody = $('body');
    const searchFormWrapper = $('.header-search-form');
    // const backdrop = $('#searchBackDropWrapper');
    if ($(pageBody).hasClass('path-search-site') === false) {
      if ($(target).hasClass('active')) {
        $('.custom-search-form').focusout();
        $(searchFormWrapper).animate({
          opacity: 0,
        }, 300);
        /*
          $(backdrop).animate({
            'opacity': 0,
          }, 300);
          */
        $('.block-crc-search-form-block').removeClass('active');
        $('.search-form-btn-wrapper').hide(400);
        $('.custom-search-form').val('');
        $(target).removeClass('active');
        $(this).removeClass('warning');
        $('.search-form-icon').text('search');
      }
      else {
        $('.search-form-btn-wrapper').show(10);
        $(searchFormWrapper).animate({
          opacity: 1,
        }, 600);
        /*
          $(backdrop).animate({
            'opacity': 0.3,
          }, 600);
          */
        $('.block-crc-search-form-block').addClass('active');
        $(target).addClass('active');
        $('.custom-search-form').focus();
        $(this).addClass('warning');
        $('.search-form-icon').text('close');
      }
    }
  });

  // modal close button
  $('.path-search-site #search-filter .modal-close i').text('close');
  /*
$('.custom-search-form').on("focusout", function(){
  if($('body').hasClass('path-search-site') === false){
      $('.search-form-icon').show(400).addClass('pulse  warning');
  }
});
*/
  // Searchform behaviour on small mobile devices
  $('.page-wrapper-mobile').on('click', () => {
    const target = $('.js-form-type-search');
    const searchFormWrapper = $('.search-form-btn-wrapper');
    if ($('body').hasClass('path-search-site') === false && $(target).hasClass('active') && $(window).width() < 481) {
      $(searchFormWrapper).animate({
        opacity: 0,
      }, 300);
      $('.custom-search-form').val('');
      $(target).removeClass('active');
      $('.search-form-icon').removeClass('warning');
      $('.search-form-icon').show();
    }
  });
  // Submitting the form
  $('.submit-form-icon').on('click', () => {
    const errorString = 'Het formulier kan niet leeg verzonden worden.';
    const warningString = 'Een zoekterm moet minimaal 3 karakters lang zijn. Pas je zoekopdracht aan.';
    // Throw a warning if the user input is less then 3 characters
    if ($('body').hasClass('path-search-site') === false) {
      if ($('#edit-search').val().length > 2) {
        $('#header-search-form').submit();
      }
    }
    else if ($('#edit-search--3').val().length > 2) {
      $('#header-search-form--2').submit();
    }
    if ($('body').hasClass('path-search-site') === false) {
      // Throw a warning if the user input is less then 3 characters
      if ($('.custom-search-form').val().length < 3 && $('.custom-search-form').val().length >= 1) {
        M.toast({
          html: Drupal.t(warningString),
          classes: 'toastWarning',
          displayLength: 5000,
        });
      }
      // Throw an error when the form is empty on submit.
      if ($('.custom-search-form').val().length === 0) {
        M.toast({
          html: Drupal.t(errorString),
          classes: 'toastError',
          displayLength: 5000,
        });
      }
    }
    else {
      // Throw a warning if the user input is less then 3 characters
      if ($('#edit-search--3').val().length < 3 && $('#edit-search--3').val().length >= 1) {
        M.toast({
          html: Drupal.t(warningString),
          classes: 'toastWarning',
          displayLength: 5000,
        });
      }
      // Throw an error when the form is empty on submit.
      if ($('#edit-search--3').val().length === 0) {
        M.toast({
          html: Drupal.t(errorString),
          classes: 'toastError',
          displayLength: 5000,
        });
      }
    }
  });
  // Check input state before submitting form  while pressing the enter button
  $('#edit-search--3').on('focusin', function () {
    const errorString = 'Het formulier kan niet leeg verzonden worden.';
    const warningString = 'Een zoekterm moet minimaal 3 karakters lang zijn. Pas je zoekopdracht aan.';
    $(this).off('keydown').keydown((event) => {
      if (event.keyCode === 13) {
        // console.log('enter!');
        event.preventDefault();
        // Throw a warning if the user input is less then 3 characters
        if ($('#edit-search--3').val().length < 3 && $('#edit-search--3').val().length >= 1) {
          M.toast({
            html: Drupal.t(warningString),
            classes: 'toastWarning',
            displayLength: 5000,
          });
        }
        // Throw an error when the form is empty on submit.
        if ($('#edit-search--3').val().length === 0) {
          M.toast({
            html: Drupal.t(errorString),
            classes: 'toastError',
            displayLength: 5000,
          });
        }
        if ($('#edit-search--3').val().length > 2) {
          $('#header-search-form--2').submit();
        }
      }
    });
  });

  // Check input state before submitting form  while pressing the enter button
  $('#edit-search').on('focusin', function () {
    const errorString = 'Het formulier kan niet leeg verzonden worden.';
    const warningString = 'Een zoekterm moet minimaal 3 karakters lang zijn. Pas je zoekopdracht aan.';
    $(this).off('keydown').keydown((event) => {
      if (event.keyCode === 13) {
        // console.log('enter!');
        event.preventDefault();
        // Throw a warning if the user input is less then 3 characters
        if ($('#edit-search').val().length < 3 && $('#edit-search').val().length >= 1) {
          M.toast({
            html: Drupal.t(warningString),
            classes: 'toastWarning',
            displayLength: 5000,
          });
        }
        // Throw an error when the form is empty on submit.
        if ($('#edit-search').val().length === 0) {
          M.toast({
            html: Drupal.t(errorString),
            classes: 'toastError',
            displayLength: 5000,
          });
        }
        if ($('#edit-search').val().length > 2) {
          $('#header-search-form').submit();
        }
      }
    });
  });

  // End searchform
  $(document).on('click', '.inline-block-list__item', () => {
    $('select').formSelect({
      isMultiple: false,
    });
    $('.tooltipped').tooltip();
  });
  $('.campaign-item.card .campaign-btn').on('mouseenter', function () {
    $(this).find('.link-icon').addClass('hover');
    $(this).addClass('hover');
  });
  $('.campaign-item.card .campaign-btn').on('mouseleave', function () {
    $(this).find('.link-icon').removeClass('hover');
    $(this).removeClass('hover');
  });
  $('.link.news-btn').on('mouseenter', function () {
    $(this).find('.link-icon').addClass('hover');
    $(this).addClass('hover');
  });
  $('.link.news-btn').on('mouseleave', function () {
    $(this).find('.link-icon').removeClass('hover');
    $(this).removeClass('hover');
  });
  const imgAnimate = $('.layout--threecol-section .field-name-field-afbeelding-solo img');
  const activeMenu = document.querySelectorAll('.mega-evidensia.menu--level-0 .menu-item div[class^="megamenu-container"]');
  // const mainMenuItems = $('.menu--level-0 .menu--parent .top-level-link');
  // const navArrow = $('.arrow-icon');
  let postionMegamenu = 0; // define variable
  // Megamenu, position and size, when appearing
  if ($('.nav-wrapper .menu-dropdown .layout .layout__region').length > 0) {
    // check if there are any .mega-containers, no check = js error on pages without .mega-container
    if ($('.nav-wrapper .mega-container').length > 0) {
      const ul = $('.mega-container');
      const ulPosition = $(ul).position();
      postionMegamenu = ulPosition.left - $(ul).outerWidth() / 2 - 30; // Styling images on campaignpage landscape images must have more width then portrait.
      // position the megamenucontainer in the center of the mainmenu
      $(activeMenu).css({
        left: `${postionMegamenu}px`,
      });
    }
  }
  // Styling images on campaignpage landscape images must have more width then portrait.
  const imgStyle = $('#builder-block-download-file img');
  const imgStyleSolo = $('#builder-block-solo-image img');

  function imageStyleWidth(elm, width) {
    $(elm).each(function () {
      const imgWidth = $(this).outerWidth();
      const imgHeight = $(this).outerHeight();
      if (imgWidth > imgHeight) {
        $(this).width(`${width}%`);
      }
    });
  }
  imageStyleWidth(imgStyle, 90);

  // Activate Tooltiops and selectfields when a ajax call is finished.
  jQuery(document).once().ajaxComplete((event, xhr, settings) => {
    $('select').formSelect();
    jQuery('.tooltipped').tooltip();
  });

  // add megamenu arrow-icon to menu-link
  $('.menu--level-0 .menu--parent > *').on('mouseover', () => {
    // add icon if class 'has-material-icon' is not present.
    if (!$('.menu--level-0 .menu--parent > .top-level-link').hasClass('has-material-icon')) {
      $('.menu--level-0 .menu--parent > .top-level-link').addClass('has-material-icon');
      $('.menu--level-0 .menu--parent > .top-level-link').append('<i class="material-icons arrow-icon">play_arrow</i>');
    }
  });
});
window.addEventListener('DOMContentLoaded', (event) => {
/* START ANIMATING H1 TITLE ON HOMEPAGE */
// Wrap every letter in a span
  if (document.querySelector('.path-frontpage')) {
    const textWrapper = document.querySelector('.welcomeMessage .letters');
    textWrapper.innerHTML = textWrapper.textContent.replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>");

    anime.timeline({ loop: false })
      .add({
        targets: '.welcomeMessage .line',
        scaleY: [0, 1],
        opacity: [0.5, 1],
        easing: 'easeOutExpo',
        duration: 700,
      }).add({
        targets: '.welcomeMessage .line',
        translateX: [0, document.querySelector('.welcomeMessage .letters').getBoundingClientRect().width + 10],
        easing: 'easeOutExpo',
        duration: 700,
        delay: 100,
      }).add({
        targets: '.welcomeMessage .letter',
        opacity: [0, 1],
        easing: 'easeOutExpo',
        duration: 600,
        offset: '-=775',
        delay: (el, i) => 34 * (i + 1),
      })
      .add({
        targets: '.welcomeMessage .letter .spanperiod',
        opacity: [0, 1],
        easing: 'easeOutExpo',
        duration: 600,
        offset: '-=775',
        delay: (el, i) => 34 * (i + 1),
      })
      .add({
        targets: '.welcomeMessage .line',
        opacity: 0,
        duration: 1000,
        easing: 'easeOutExpo',
        delay: 0,
      });
  }
  /* START ANIMATING H1 TITLE */

  /* START ANIMATING H1 PAGETITLE */
  if (document.querySelector('.page-node-type-campaign')) {
    const pageTitleWrapper = document.querySelector('.pageTitle .letters');
    pageTitleWrapper.innerHTML = pageTitleWrapper.textContent.replace(/\S/g, "<span class='letter'>$&</span>");

    anime.timeline({ loop: false })
      .add({
        targets: '.pageTitle .letter',
        scale: [0.3, 1],
        opacity: [0, 1],
        translateZ: 0,
        easing: 'easeOutExpo',
        duration: 600,
        delay: (el, i) => 70 * (i + 1),
      }).add({
        targets: '.pageTitle .line',
        scaleX: [0, 1],
        opacity: [0.5, 1],
        easing: 'easeOutExpo',
        duration: 700,
        offset: '-=875',
        delay: (el, i, l) => 80 * (l - i),
      }).add({
        targets: '.pageTitle',
        opacity: 1,
        duration: 1000,
        easing: 'easeOutExpo',
        delay: 1000,
      });
  }
/* END ANIMATING H1 PAGETITLE */
});
